// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 07-12-2025

import GoldLoanArrearReportTypes from './gold-loan-arrear-report.types';
import { docodeHexResponse } from '../../_common/common.utils';
const INITIAL_STATE = {
	fetchGoldArrearReportDetailsResponse: null,
	fetchGoldArrearReportDetailsArr: [],
};

const goldLoanArrearReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************* GOLD LOAN ARREAR REPORT START *********** */
		case GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_SUCCESS:
			return {
				...state,
				fetchGoldArrearReportDetailsResponse: action.payload,
				fetchGoldArrearReportDetailsArr: docodeHexResponse(
					action.payload,
					'FetchGoldLoanArrearReportKey',
				),
			};

		case GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_FAILURE:
			return { ...state, fetchGoldArrearReportDetailsResponse: action.payload };

		case GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchGoldArrearReportDetailsResponse: null };
		/************* GOLD LOAN ARREAR REPORT START *********** */
		default:
			return state;
	}
};

export default goldLoanArrearReportReducer;
